String.prototype.afterLast = function(char) {
   return this.substring(this.lastIndexOf('/') + 1);
};

String.prototype.beforeLast = function(char) {
   return this.substring(0, this.lastIndexOf('.'))
};

String.prototype.encodeHTML = function() {
   var htmlEscapes = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#x27;',
      '/': '&#x2F;'
   };

   return this.replace(/[&<>"'\/]/g, function(match) {
      return htmlEscapes[match];
   });
};

String.prototype.isBetween = function(from, to) {
   return this >= from && this <= to;
}